// Shared product-selection logic for the dynamic storefront rows
// (Uitgelicht/Nieuw binnen/Meest verkocht/Acties). Used by both the live
// storefront (ShopHomePage) and the theme editor's live preview so the two
// never disagree about which products a given row shows.
export const deriveProductCollections = (products = [], bestsellerIds = []) => {
  const featured_products = products.slice(0, 8);
  const new_products = [...products]
    .sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0))
    .slice(0, 8);
  const bestseller_products = bestsellerIds
    .map((id) => products.find((p) => p.id === id))
    .filter(Boolean);
  const deals_products = products.filter(
    (p) => p.sale_price !== null && p.sale_price !== undefined && p.sale_price < p.price
  );
  return { featured_products, new_products, bestseller_products, deals_products };
};
